module.exports = __webpack_public_path__ + "static/media/Banner_a_tecnologia_do_futuro-06.160bae0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/A_Tecnoliga_do_futuro/Banner_a_tecnologia_do_futuro-06.png
// module id = 105
// module chunks = 0